"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangelogFieldName = void 0;
var ChangelogFieldName;
(function (ChangelogFieldName) {
    ChangelogFieldName["Name"] = "Name";
    ChangelogFieldName["Description"] = "Description";
    ChangelogFieldName["PlaceOfPerformance"] = "PlaceOfPerformance";
    ChangelogFieldName["Published"] = "Published";
    ChangelogFieldName["SubmissionDeadline"] = "SubmissionDeadline";
    ChangelogFieldName["ContractDuration"] = "ContractDuration";
    ChangelogFieldName["ContractRenewal"] = "ContractRenewal";
    ChangelogFieldName["EstimatedValue"] = "EstimatedValue";
    ChangelogFieldName["TypeOfProcedure"] = "TypeOfProcedure";
    ChangelogFieldName["ClarificationDeadline"] = "ClarificationDeadline";
    ChangelogFieldName["EvaluationModel"] = "EvaluationModel";
    ChangelogFieldName["ContractStart"] = "ContractStart";
    ChangelogFieldName["ContractEnd"] = "ContractEnd";
    ChangelogFieldName["LinkToSubmit"] = "LinkToSubmit";
    ChangelogFieldName["FrameworkAgreement"] = "FrameworkAgreement";
    ChangelogFieldName["Subject"] = "Subject";
    ChangelogFieldName["Received"] = "Received";
})(ChangelogFieldName = exports.ChangelogFieldName || (exports.ChangelogFieldName = {}));
